import React, { useState, Fragment, useEffect, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import '../styles.css';
import PlanA from './plana';
import PlanB from './planb';
import { activatieLicenses, getMyActiveLicenses, handleUpdateActivation } from '../../../actions/license';
import { dateFormat } from '../../../utils';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import CreateRoom from './createRoom';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import LicenseModal from '../../Dashboard/components/ProductModel';

const EnterpriseConferenceRoom = (props) =>
{
	const { planId } = props;
	const [ pack, setPack ] = useState('');
	const [ MyLicenses, setMyLicenses ] = useState([]);
	const [ isOpen, setOpen ] = useState({ status: false, type: null, data: null });
	const history = useHistory();
	const [ model, setModel ] = useState(false);
	const [ id, setId ] = useState('');
	const [ isCreate, setIsCreate ] = useState(true);

	useEffect(() =>
	{
		if (planId)
		{
			getMyActiveLicenses(planId).then((res) =>
			{
				// eslint-disable-next-line no-console
				// console.log('res ==== ', res);
				if (res && res.status)
				{
					setMyLicenses([ ...res.data.data ]);
				}
				else
				{
					setMyLicenses([]);
				}
			})
				.catch((err) =>
				{
					setMyLicenses([]);
				});
		}
	}, [ planId, isOpen ]);

	const handleActivate = useCallback((roomName) =>
	{
		const body = {
			_id  : isOpen.data._id,
			roomName,
			type : isOpen.type
		};

		// eslint-disable-next-line no-console
		// console.log('body', body);
		activatieLicenses(body).then((res) =>
		{
			// eslint-disable-next-line no-console
			// console.log('res handle Activation', res);
			if (res.data && res.data.status)
			{
				toast.success(res?.data?.message);
				setOpen({ status: false, type: null, data: null });
				history.push(`/meet/${res?.data?.data?._id}`);
				// getData();
			}
			else
			{
				toast.error(res?.data?.message);
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line no-console
				console.log('err ==== ', err);
				toast.error('Internal Server Error, Please try again');
			});
	}, [ planId, isOpen ]);

	let count =0;

	const handleUpdate = useCallback((obj) =>
	{
		const body = {
			id   : obj.id,
			name : obj.name
		};

		handleUpdateActivation(body).then((res) =>
		{
			// eslint-disable-next-line no-console
			// console.log('res handle Activation', res);
			if (res.data && res.data.status)
			{
				toast.success(res?.data?.message);
				setOpen({ status: false, type: null, data: null });
			}
			else
			{
				toast.error(res?.data?.message);
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line no-console
				console.log('err ==== ', err);
				toast.error('Internal Server Error, Please try again');
			});
	}, []);

	return (
		<Fragment>
			<div className='flexCol alignCntr baseBg pdngLG dashboardCntnr'>
				<div className='flexCol alignCntr whiteTxt LinearGradientGreen brdrRadiusSM pdngXS'>
					<h3 className='fontWeightNormal textCntr'>ENTERPRISE CONFERENCE ROOM</h3>
				</div>
				<div className='resRowColM justifyCntr alignCntr fullWidth pdngTMD mrgnTXLG'>
					<div className='flexMinWidthCol justifyBtwn alignCntr pdngMD mrgnTXLG'>
						<div className='flexAutoCol'>
							{/* <h3 className='mrgnTXLG textCntr'>1 KONX PACK FOR $250</h3> */}
							<div className='flexCol alignCntr pdngVSM'>
								<ul className='flexCol alignCntr featuresCntnr'>
									<li className='flexRow justifyCntr textCntr'>Maximum of 80 hours within the Current Month Period</li>
									<li className='flexRow justifyCntr textCntr'> Up to 1000 Participants / Meeting </li>
									<li className='flexRow justifyCntr textCntr'> Maximum of 5 Hours / Meeting</li>
								</ul>
							</div>
						</div>
						<div className='row w-100 mt-3'>
							{MyLicenses.map((item, index) =>
							{
								if (item.type === 'eCard' && item.planId === 'EnterpriseRoom')
								{
									count++; // Increment only for valid items

									return (
										<div className='col-12 col-sm-6 col-md-4 text-center' key={index}>
											<small className='bold'>ECR {count}</small> {/* Display the current count */}
											{item.expireDate ? (
												<div className='flexCol w-100 whiteTxt py-2 alignCntr LinearGradientGreen brdrRadiusSM mrgnVSM purchaseCard'>
													<span>{item.name}</span>
													{item.expireDate >= new Date().valueOf() ? (
														<span>Valid till: {dateFormat(item.expireDate)}</span>
													) : (
														<span>Expired</span>
													)}
													{item.expireDate >= new Date().valueOf() &&<div className='displayHover whiteTxt' >
														<div className='d-flex w-100 justifyBtwn' >
															<div className='d-flex flex-column px-3 w-50 resAlignCntr' onClick={() => { setOpen({ status: true, type: item.type, data: item }); setIsCreate(false); }}>
																<EditOutlinedIcon/>
																<span>Edit</span>
															</div>
															<div className='d-flex flex-column px-3 w-50 resAlignCntr' onClick={() => { setId(item._id); setModel(true); }}>
																<VisibilityOutlinedIcon/>
																<span>View</span>
															</div>
														</div>
													</div>}
												</div>

											) : (
												<div className='cursor-pointer flexCol alignCntr resWidth35 LinearGradientGreen brdrRadiusSM mrgnVSM' onClick={() => { setOpen({ status: true, type: item.type, data: item }); setIsCreate(true); }}>
													<Button className='whiteTxt' >
														ACTIVATE
													</Button>
												</div>
											)}
										</div>
									);
								}

								return null; // Return null for non-valid items
							})}

						</div>
					</div>
				</div>
				{/* <div className='flexCol justifyCntr alignCntr pdngVLG mrgnTLG redTxt'>
					<h3 className='textCntr'>USE THE SAME SAMPLE LINKS FROM THE PREVIOUS SLIDES</h3>
				</div> */}
				{/* <div className='flexCol whiteTxt LinearGradientGreen brdrRadiusSM mrgnTSM txtleft'> */}
				{/* <h4 className='pdngXXS'>www.konx.biz</h4> */}
				{/* </div> */}
			</div>
			<CreateRoom
				open={isOpen?.status} handleClose={() => setOpen({ status: false, type: null, data: null })} handleSave={handleActivate}
				data={isOpen.data && !isCreate ?isOpen.data:null}
				handleUpdate={handleUpdate}
				name={'Enterprise'}
			/>
			<LicenseModal open={model} handleClose={() => setModel(false)} id={id}/>
		</Fragment>
	);
};

export default EnterpriseConferenceRoom;